<template >


  <v-layout
          row
  >

    <v-flex xs12 sm6 offset-sm3>

      <template v-for="(catObj,catOrdersIndex) in catOrders">
        <div :key="'catOrdersIndex-'+catOrdersIndex">

          <h3 class="my-3 pl-2">
            <a :name="'cat_'+catObj.id" class="black--text"
            >{{ catObj.name }}</a>
          </h3>

          <v-layout row wrap>
            <template v-for="(item,itemInCatIndex) in catObj.itemObjs">
              <v-flex
                      :key="'cat_'+catOrdersIndex+'_item_'+itemInCatIndex"
                      xs6
                      pa-1
                      @click.stop.prevent="goDetail(item.itemId,$event)"
              >
                <v-card color="white" :class="menuCardClass(itemInCatIndex,catObj.itemObjs)" >
                  <v-img :src="item.photo" aspect-ratio="1.90" contain v-if="item.photo"></v-img>
                  <div class="pt-2 "><b><a :href="itemHref(item.itemId)" class="black--text no-underline item_title" @click.stop.prevent="goDetail(item.itemId,$event)">
                    {{item.title}}
                  </a></b></div>
                  <div class="price">
                    {{ prices[item.itemId].price }}
                  </div>

                </v-card>

              </v-flex>
            </template>

          </v-layout>


        </div>
      </template>



    </v-flex>
  </v-layout>

</template>

<script>
  import  { Logger } from 'aws-amplify';
  const logger = new Logger('ItemList','INFO');
  import { AmplifyEventBus } from 'aws-amplify-vue'
  import {PriceMixIns} from '../mixins/price'
  //import moment from 'moment-timezone'


  export default {

    mixins:[PriceMixIns],
    data () {
      return {
        list:undefined,
        shopName:undefined,
        lang:undefined,
        currency:undefined,
        prices:{}
        //
      }
    },
    created() {
      AmplifyEventBus.$on('shopName', this.setShopName )
      AmplifyEventBus.$on('menu', this.prepareList )
      AmplifyEventBus.$on('priceWithTax', this.priceWithTax )
    },
    beforeDestroy () {
      logger.info("Home beforeDestroy")
      //AmplifyEventBus.$emit('showCatMenu',"hide" )
      AmplifyEventBus.$off('shopNameLang', this.setShopNameLang )
      AmplifyEventBus.$off('menu', this.prepareList )
      AmplifyEventBus.$off('priceWithTax', this.priceWithTax )

    },
    async mounted() {
      //AmplifyEventBus.$emit('showCatMenu',"show" )
      AmplifyEventBus.$emit('setBackTo', "none" )
      AmplifyEventBus.$emit('setBottomBar', "itemList" )
      AmplifyEventBus.$emit('getShopNameLang', "none" )
      //AmplifyEventBus.$emit('checkIsOpen', moment() )
      if(!this.list){
        AmplifyEventBus.$emit('requestMenu')
      }
      this.trackPage('/ItemList/')
      document.title = this.$store.state.shopName + " | 商品一覧"
      AmplifyEventBus.$emit('setJourney', {key:"page",value:document.title} )
    },
    methods:{
      menuCardClass:function(index,obj){
        //logger.info("index",index)
        let res = "pa-2 "
        const prev = index - 1
        const next = index + 1
        if(index%2 == 0){
          if(obj[index].photo){
            res += " menu_card"
          }else if(obj[next] && obj[next].photo){
            //logger.info("next has photo")
            res += " menu_card"
          }else{
            res += " menu_card_no_photo"
          }
        } else {
          if(obj[index].photo){
            res += " menu_card"
          }else if(prev && obj[prev] && obj[prev].photo){
            //logger.info("prev has photo")
            res += " menu_card"
          }else{
            res += " menu_card_no_photo"
          }
        }

        return res
      },
        itemHref:function(itemId){
          const path = '/detail/?itemId='+itemId+this.placeIdParam
          return path
        },
        goDetail:function(itemId,event){
            logger.info("goDetail event",event)
            const posY = event.pageY - 200
            sessionStorage.setItem("itemListMousePos",JSON.stringify({posY:posY,time:Date.now()}))
            const path = '/detail/?itemId='+itemId+this.placeIdParam
            this.$router.push(path)
        },
      setShopNameLang:function(res){
        //logger.info("setShopName",shopName)
        this.shopName = res.shopName
        this.lang = res.lang


      },
      prepareList:function(menu){
        if(!menu.itemsAndInventories || !menu.itemsAndInventories.categoriesAndOrder){
          logger.info("no menu.categoriesAndOrder yet")
          return
        }
        const res = []
        logger.info("preparing a list")
        logger.info(menu.defalutSettings)
        this.lang = menu.defalutSettings.defaultLang
        this.currency = menu.defalutSettings.currency

        for(let i in menu.itemsAndInventories.categoriesAndOrder.order){
          const catId = menu.itemsAndInventories.categoriesAndOrder.order[i]
          const cat = menu.itemsAndInventories.categoriesAndOrder.categories[catId]
          for(let j in cat.items){
            let resItem = {}
            if(j == 0){
              resItem.type = "cat"
              resItem.title = cat.name[this.lang]
              resItem.id = encodeURIComponent(catId)
              res.push(resItem)
            }
            const itemId = cat.items[j]
            if(menu.itemsAndInventories.items[itemId]){
              const item = menu.itemsAndInventories.items[itemId]
              resItem = {}
              resItem.type = "item"
              resItem.title = item.name[this.lang]
              if(item.photos && item.photos[0]){
                resItem.photo = item.photos[0]
              }
              resItem.itemId = itemId
              //
              const dataToEmit = {}
              dataToEmit.itemId = itemId
              dataToEmit.priceDiff = 0 // difference to original price due to selection of options
              AmplifyEventBus.$emit('getPriceWithTax', dataToEmit)
              res.push(resItem)
            }

          }

        }
        logger.info("list",res)

        this.list = res

      },
      priceWithTax:function(data){

        //logger.info("priceWithTax data",data)
        this.prices[data.itemId] = {}
        this.prices[data.itemId].priceNaked = data.priceNaked
        this.prices[data.itemId].price = this.getCurrencyFormatted(data.priceNaked)
        //logger.info("priceWithTax prices",this.prices)
      },

    },
    computed:{
      placeIdParam:function(){
        if(this.$store.state.placeIdParam){
          return "&p="+this.$store.state.placeIdParam
        }else{
          return ""
        }
      },
      catOrders:function(){
        const menu = this.$store.state.menu
        const res = []
        if(!menu || !menu.itemsAndInventories){
          return res
        }
        for(let i in menu.itemsAndInventories.categoriesAndOrder.order){
          const catId = menu.itemsAndInventories.categoriesAndOrder.order[i]
          const cat = menu.itemsAndInventories.categoriesAndOrder.categories[catId]
          //logger.info("catOrders cat",cat)
          if(cat && cat.items){
            const obj={}
            obj.name = cat.name[this.lang]
            obj.catId = catId
            obj.id = encodeURIComponent(catId)
            obj.itemObjs = []
            for(let j in cat.items){
              const itemId = cat.items[j]
              if(menu.itemsAndInventories.items[itemId]){
                const item = menu.itemsAndInventories.items[itemId]
                const resItem = {}
                resItem.type = "item"
                resItem.title = item.name[this.lang]
                if(item.photos && item.photos[0]){
                  resItem.photo = item.photos[0]
                }
                /*
                if(item.description && item.description[this.lang]){
                  resItem.description = item.description[this.lang]
                }

                 */
                resItem.itemId = itemId
                //
                const dataToEmit = {}
                dataToEmit.itemId = itemId
                dataToEmit.priceDiff = 0 // difference to original price due to selection of options
                AmplifyEventBus.$emit('getPriceWithTax', dataToEmit)
                obj.itemObjs.push(resItem)
              }
            }
            res.push(obj)
          }
        }
        return res
      }
    }

  }

</script>

<style>
  .avatar_photos{
    object-fit:cover;
  }

  a.subheader{
    color:gray;
    cursor:default;
  }

  .no-underline{
    text-decoration: none;
  }

  .menu_card .price{
    position: absolute;
    bottom:8px;
    font-weight: bold;
  }

  .item_title{
    display:block;
    line-height: 21px;
    height:42px;
    overflow: hidden;
  }

  @media (max-width: 599px) {
    .menu_card{
      border-radius: 10px;
      height: calc(50vw - 4px);
    }
  }

  @media (min-width: 600px) {
    .menu_card{
      border-radius: 10px;
      height: calc(21vw - 4px);
    }
  }

  .menu_card_no_photo{
    border-radius: 10px;
    height: 100px;
  }

  .menu_card_no_photo .price{
    position: absolute;
    bottom:8px;
    font-weight: bold;
  }

</style>